
import React from 'react';
import { MockStock2026 } from '../views';


const MiddleSchoolPage = () => {
  return <MockStock2026/>;
};

export default MiddleSchoolPage;